import { Notes, Image } from 'mdx-deck';
import { GatsbyLogo, ShoptetLogo, ReactLogo, NextLogo, SmallImg, MiddleImg } from "../../../../../../talk/images";
import myTheme from "../../../../../../talk/theme";
import { prism } from 'mdx-deck/themes';
import React from 'react';
export default {
  Notes: Notes,
  Image: Image,
  GatsbyLogo: GatsbyLogo,
  ShoptetLogo: ShoptetLogo,
  ReactLogo: ReactLogo,
  NextLogo: NextLogo,
  SmallImg: SmallImg,
  MiddleImg: MiddleImg,
  myTheme: myTheme,
  prism: prism,
  React: React
};